import React from "react";
import docFile from '../abstracts/VETOMAC_2023_Word_Template.docx';

function Template() {

    const downloadTemplate = () => {
        fetch(docFile).then(response => {
            response.blob().then(blob => {
                const fileURL = window.URL.createObjectURL(blob);
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = 'VETOMAC_2023_Word_Template.docx';
                alink.click();
            })
        })
    }

    return (
        <div className="keydates">
            <h2 className="compTitle">Full Paper Submission Template</h2>
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '3vmax'}}>
                <a onClick={downloadTemplate} style={{width: 'fit-content', padding: '0.5vmax 3vmax'}} className="download">Download Word Template</a>
            </div>
        </div>
    )
}

export default Template;